module.exports = __webpack_public_path__ + "img/orange_036.3657f793.png";